import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useState } from 'react';
import { INITAL_CONTEXT_VALUE } from './Tabs.constants';
// Component.
// -----------------------------------------------------------------------------
// Context definition.
export const TabsContext = createContext(INITAL_CONTEXT_VALUE);
// Context provider.
export const TabsContextProvider = ({ children, activeTabId, onTabChange }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const [currentIndex, setCurrentIndex] = useState(activeTabId || INITAL_CONTEXT_VALUE.selectedTabId);
    useEffect(() => {
        if (activeTabId) {
            setCurrentIndex(activeTabId);
        }
    }, [activeTabId]);
    // Render.
    // ---------------------------------------------------------------------------
    return (_jsx(TabsContext.Provider, { value: {
            selectedTabId: currentIndex,
            setSelectedTabId: (tabId) => {
                onTabChange?.(tabId);
                setCurrentIndex(tabId);
            }
        }, children: children }));
};
//# sourceMappingURL=Tabs.context.js.map